export default __webpack_public_path__ + "static/media/Dacia Maraini e Stefano Malatesta.efb833fc.jpg";